var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    width: 800,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #a3b5a9 } \n\t\t.s1 { fill: #ebebeb } \n\t\t.s2 { fill: #617d6a } \n\t\t.s3 { fill: #7d9083 } \n\t\t.s4 { fill: #8bab96 } \n\t\t.s5 { fill: #749780 } \n\t\t.s6 { fill: #70917c } \n\t\t.s7 { fill: #98bba4 } \n\t\t.s8 { fill: #47695d } \n\t\t.s9 { fill: #415e55 } \n\t\t.s10 { fill: #506961 } \n\t\t.s11 { fill: #e3ba96 } \n\t\t.s12 { fill: #263238 } \n\t\t.s13 { fill: #61876e } \n\t\t.s14 { opacity: .5;fill: #568771 } \n\t\t.s15 { opacity: .2;fill: #000000 } \n\t\t.s16 { opacity: .5;fill: #4b8773 } \n\t\t.s17 { opacity: .5;fill: #263238 } \n\t\t.s18 { opacity: .6;fill: #263238 } \n\t\t.s19 { fill: #ed893e } \n\t\t.s20 { fill: #2e353a } \n\t\t.s21 { fill: #de5753 } \n\t\t.s22 { fill: #ffffff } \n\t\t.s23 { opacity: .8;fill: #ffffff } \n\t\t.s24 { fill: #568771 } \n\t\t.s25 { opacity: .1;fill: #000000 } \n\t\t.s26 { opacity: .7;fill: #fafafa } \n\t\t.s27 { opacity: .1;fill: #263238 } \n\t\t.s28 { fill: #82b593 } \n\t\t.s29 { fill: #1d4433 } \n\t\t.s30 { opacity: .1;fill: #ffffff } \n\t\t.s31 { opacity: .3;fill: #ffffff } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-8",
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m-14.7 634.1h829.4v0.4h-829.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m158.7 645.4h55v0.4h-55z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m269.2 660.6h67.6v0.4h-67.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m72.3 655.4h84.8v0.4h-84.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m577.1 648.2h154.5v0.4h-154.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m551.8 648.2h10.5v0.4h-10.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m445.1 655.2h70.1v0.4h-70.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m378.4 560.1h-320.3c-1.2 0-2.4-0.2-3.6-0.7-1.1-0.5-2.2-1.2-3-2.1-0.9-0.9-1.6-1.9-2.1-3-0.5-1.2-0.7-2.4-0.7-3.7v-450.2c0-1.2 0.2-2.5 0.7-3.6 0.5-1.1 1.2-2.2 2.1-3 0.9-0.9 1.9-1.6 3-2.1 1.2-0.5 2.4-0.7 3.6-0.7h320.3c1.3 0 2.5 0.2 3.7 0.7 1.1 0.5 2.2 1.2 3 2.1 0.9 0.9 1.6 1.9 2.1 3 0.5 1.2 0.7 2.4 0.7 3.7v450.1c0 1.3-0.2 2.5-0.7 3.7-0.5 1.1-1.2 2.2-2.1 3-0.8 0.9-1.9 1.6-3 2.1-1.2 0.5-2.4 0.7-3.7 0.7zm-320.3-468.8c-1.1 0-2.3 0.3-3.4 0.7-1.1 0.5-2.1 1.1-3 2-0.8 0.8-1.5 1.8-1.9 2.9-0.5 1.1-0.7 2.3-0.7 3.5v450.2c0 1.2 0.2 2.4 0.7 3.5 0.4 1.1 1.1 2.1 1.9 2.9 0.9 0.9 1.9 1.5 3 2 1.1 0.5 2.3 0.7 3.4 0.7h320.3c1.2 0 2.4-0.2 3.5-0.7 1.1-0.5 2.1-1.1 2.9-2 0.9-0.8 1.5-1.8 2-2.9 0.5-1.1 0.7-2.3 0.7-3.5v-450.2c0-1.2-0.2-2.4-0.7-3.5-0.5-1.1-1.1-2.1-2-2.9-0.8-0.9-1.8-1.5-2.9-2-1.1-0.4-2.3-0.7-3.5-0.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m737.2 560.1h-320.3c-1.2 0-2.4-0.2-3.6-0.7-1.1-0.5-2.2-1.2-3.1-2.1-0.8-0.9-1.5-1.9-2-3-0.5-1.2-0.7-2.4-0.7-3.7v-450.2c0-1.2 0.2-2.5 0.7-3.6 0.5-1.1 1.2-2.2 2.1-3.1 0.9-0.8 1.9-1.5 3-2 1.2-0.5 2.4-0.7 3.6-0.7h320.3c1.3 0 2.5 0.2 3.6 0.7 1.2 0.5 2.2 1.2 3.1 2.1 0.9 0.8 1.6 1.9 2 3 0.5 1.1 0.8 2.4 0.8 3.6v450.2c0 1.3-0.3 2.5-0.7 3.7-0.5 1.1-1.2 2.1-2.1 3-0.9 0.9-1.9 1.6-3 2.1-1.2 0.5-2.4 0.7-3.7 0.7zm-320.3-468.8c-1.2 0-2.3 0.3-3.4 0.7-1.1 0.5-2.1 1.1-3 2-0.8 0.8-1.5 1.8-1.9 2.9-0.5 1.1-0.7 2.3-0.7 3.5v450.2c0 1.2 0.2 2.4 0.7 3.5 0.4 1.1 1.1 2.1 1.9 2.9 0.9 0.9 1.9 1.5 3 2 1.1 0.5 2.2 0.7 3.4 0.7h320.3c1.2 0 2.4-0.2 3.5-0.7 1.1-0.5 2.1-1.1 2.9-2 0.9-0.8 1.6-1.8 2-2.9 0.5-1.1 0.7-2.3 0.7-3.5v-450.2c0-1.2-0.2-2.4-0.7-3.5-0.4-1.1-1.1-2.1-2-2.9-0.8-0.9-1.8-1.5-2.9-2-1.1-0.4-2.3-0.7-3.5-0.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m367.5 300.4v333.7h-134v-333.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m360.1 301.7v98.3h-119.2v-98.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m240.9 415.8h119.2v98.2h-119.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m240.9 522.9h119.2v98.2h-119.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m360.1 308.7v98.3h-46.9v-98.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m313.2 415.8h46.9v98.2h-46.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m259.7 474.8h32.5v39.2h-32.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m246 474.8h13.7v39.2h-13.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m312.2 474.8h32.5v39.2h-32.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m298.5 474.8h13.7v39.2h-13.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m286.6 435.5h32.5v39.3h-32.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m272.8 435.5h13.8v39.3h-13.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m313.2 522.9h46.9v98.2h-46.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m197.1 300.4h36.4v333.7h-36.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m255.2 537h96.8v84.1h-96.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m255.2 621.1h-14.3v-84.1h14.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m255.2 322.9h96.8v84.1h-96.8z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m240.9 322.9h14.3v84.1h-14.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m691.9 145.2v488.9h-230.7v-488.9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m461.2 145.2v488.9h-0.9v-488.9z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m477.9 161.2h188.3v472.9h-188.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m482.6 161.2h193.7v472.9h-193.7z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m662.2 401.6h6l-6 5.9v-5.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m662.2 175.4v444.6h-165.5v-444.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m660.4 399.2v9.1h-29c-1.2 0-2.3-0.5-3.2-1.3-0.9-0.9-1.3-2-1.3-3.3 0-1.2 0.4-2.3 1.3-3.2 0.9-0.8 2-1.3 3.2-1.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m533 620l50.5-444.6h34l-50.5 444.6h-34z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m574.3 620l50.5-444.6h13.3l-50.5 444.6h-13.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m660.4 178.3h1.8v444.7h-1.8z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m666.6 402.2h-29q-0.9 0-1.7-0.3-0.9-0.4-1.5-1-0.7-0.7-1-1.5-0.4-0.8-0.4-1.7 0-0.9 0.4-1.8 0.3-0.8 1-1.5 0.6-0.6 1.5-1 0.8-0.3 1.7-0.3h29q0.9 0 1.7 0.3 0.9 0.4 1.5 1 0.7 0.7 1 1.5 0.4 0.9 0.4 1.8 0 0.9-0.4 1.7-0.3 0.9-1 1.5-0.6 0.6-1.5 1-0.8 0.3-1.7 0.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m91.4 201.9h81.4v129.5h-81.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m93.6 201.9h84.1v129.5h-84.1z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m100.6 211.3h70.1v110.7h-70.1z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m206.4 139.4h81.4v129.5h-81.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m208.5 139.4h84.2v129.5h-84.2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m215.6 259.5v-110.7h70.1v110.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-8",
    style: {
      opacity: 0.5
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-8",
    className: "s4",
    d: "m400 709c-177.9 0-321.6-8.4-321.6-18.8 0-10.4 143.7-18.8 321.6-18.8 177.9 0 321.6 8.4 321.6 18.8 0 10.4-143.7 18.8-321.6 18.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m255.2 674.7l0.5-28.5h12.3l-0.5 28.5h-12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m163.7 652.8l12.3-26.3 12 3.1-12.4 26.3-11.9-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m177.7 654.8q0.3 0.2 0.5 0.3 0.2 0.2 0.4 0.4 0.1 0.2 0.3 0.5c2.1 3.6 7.5 8.9 15.9 13.9 1.8 1.1-0.3 5.7-5.2 4.1-4.9-1.7-15-5.9-18.6-7.1-5.7-2-8-2.5-12.7-3.9q-0.3-0.2-0.7-0.4-0.3-0.3-0.4-0.7-0.2-0.4-0.1-0.8 0-0.4 0.2-0.8l5.6-9.7q0.1-0.1 0.2-0.2 0.1-0.2 0.3-0.2 0.2-0.1 0.3-0.1 0.2 0 0.4 0.1l13.1 4.4q0.3 0.1 0.5 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m268.2 673.3q0.4 0.1 0.7 0.2 0.4 0.2 0.8 0.3 0.3 0.2 0.7 0.4c8.4 5.2 11.6 5.4 21.3 7.5 2.1 0.5 0.9 5.6-4.2 5.6-8.4 0-9.9-0.4-17-0.4-6.1 0-13.1 0.4-18 0.4q-0.4 0-0.7-0.2-0.4-0.2-0.7-0.5-0.3-0.3-0.4-0.7-0.1-0.4 0-0.8l2.3-11q0-0.2 0.1-0.4 0.1-0.1 0.3-0.2 0.1-0.1 0.3-0.2 0.1-0.1 0.3-0.1h13.4q0.4 0.1 0.8 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m264.2 284.9l16.8-5.4c0 0 17.4 40.3 23.2 42.8 8 3.3 14.2 9 24.3 9.9 1.4 1.6 3.7 6.7 3.5 8.6-13.7 5.1-34.7-0.4-40.5-5.7-13.3-12.2-27.3-50.2-27.3-50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m287.2 279q1.9 3.5 3.7 7.2 1.8 3.7 3.3 7.5 1.6 3.8 2.9 7.6 1.4 3.9 2.6 7.8l-25.2 11.6c0 0-19-34.2-14.2-45 5.2-11.9 19-10.5 26.9 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m287.2 279q1.9 3.5 3.7 7.2 1.8 3.7 3.3 7.5 1.6 3.8 2.9 7.6 1.4 3.9 2.6 7.8l-25.2 11.6c0 0-19-34.2-14.2-45 5.2-11.9 19-10.5 26.9 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m326.4 332.3l9.5-5 4.9 13.9c0 0-3.1 1.4-12 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m345.4 323.8l3 11.9-7.6 5.6-4.9-14 9.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m268 646.2l-0.2 14.7h-12.4l0.3-14.7h12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m176 626.5l12 3.1-6.4 13.5-11.9-3 6.3-13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m276.4 268.7c0 0 15.4 42.3 3.3 111.6h-65.9c-0.7-10.1 4.4-64.6-6.5-112.3q2.7-0.5 5.5-0.9 2.7-0.5 5.5-0.8 2.7-0.4 5.5-0.6 2.7-0.3 5.5-0.4 3.5-0.2 7-0.3 3.5-0.1 7-0.1 3.5 0 7 0.1 3.5 0.1 7 0.3 2.4 0.2 4.8 0.5 2.4 0.4 4.8 0.8 2.4 0.4 4.8 0.9 2.3 0.6 4.7 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m276.4 268.7c0 0 15.4 42.3 3.3 111.6h-65.9c-0.7-10.1 4.4-64.6-6.5-112.3q2.7-0.5 5.5-0.9 2.7-0.5 5.5-0.8 2.7-0.4 5.5-0.6 2.7-0.3 5.5-0.4 3.5-0.2 7-0.3 3.5-0.1 7-0.1 3.5 0 7 0.1 3.5 0.1 7 0.3 2.4 0.2 4.8 0.5 2.4 0.4 4.8 0.8 2.4 0.4 4.8 0.9 2.3 0.6 4.7 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m221.9 279.8c1.3 7.9-0.7 26.6-7.7 48.3q-0.1-6.9-0.5-13.9-0.4-6.9-1.2-13.9-0.7-6.9-1.8-13.8-1-6.9-2.4-13.7v-0.1c4.4-0.4 12.4-0.2 13.6 7.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "face copy 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m241.5 274.2c-17.6-0.6-11.3-7.9-11-11.4 0 0 1.4 0.5 1.9-1.6 2-8.7 0.2-20.8-1.7-28.2l21 14.7c-1.1 4.9-1.5 11 1.4 15.2q0.3 0.5 0.8 0.9 0.4 0.4 0.9 0.7 0.5 0.3 1 0.4 0.6 0.2 1.2 0.3l2.1 0.2c4.5 4.5-0.4 9.3-17.6 8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m239.2 239l12.5 8.7q-0.2 0.7-0.3 1.4-0.1 0.7-0.2 1.4-0.1 0.7-0.2 1.4-0.1 0.7-0.1 1.4c-4.5 0.9-11.2-3.4-11.9-7.8q-0.1-0.8-0.2-1.6 0-0.8 0-1.6 0.1-0.8 0.2-1.7 0.1-0.8 0.2-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m249.1 202.8c0 0 10.9-3.1 11.7 1.1q0.2 0.8 0.1 1.5-0.2 0.8-0.6 1.5-0.5 0.7-1.2 1.1-0.7 0.4-1.5 0.5v9.1l-11.7-11.7 0.6-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m227.9 224.2c-0.7-2.7-0.7-5.6 0-8.4 0.7-2.7 2.2-5.2 4.1-7.3 2-2 4.5-3.5 7.2-4.4 2.7-0.8 5.6-0.9 8.4-0.4 12.5 2.7 17.3 20.2 16.6 31.4-0.8 12.4-14.6 20.7-25.3 13.1-7.2-5.1-8.2-12.2-11-24z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Folder 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape 1",
    className: "s17",
    d: "m250.6 245.5c0 0 3.9 6.4 8.1-0.7 0 0-4.3-2.4-8.1 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 2",
    className: "s18",
    d: "m261 234c0 0-7.3-5.1-16 0 0 0 7.3-2 16 0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m253.7 221q0.6 1 1.3 2 0.7 1 1.5 1.9 0.7 1 1.6 1.9 0.8 0.8 1.7 1.7-0.5 0.4-1 0.8-0.5 0.3-1.1 0.5-0.6 0.3-1.2 0.3-0.6 0.1-1.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m246.9 220.6c0.6-0.2 1.2 0.5 1.4 1.4 0.1 0.9-0.3 1.6-0.8 1.8-0.6 0.2-1.3-0.5-1.4-1.4-0.2-1 0.2-1.7 0.8-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m257.2 219.2c0.7-0.2 1.3 0.5 1.4 1.4 0.2 0.9-0.2 1.6-0.8 1.8-0.6 0.2-1.2-0.5-1.4-1.4-0.1-1 0.2-1.7 0.8-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m242.4 219.4q-0.1 0.1-0.1 0.1 0 0-0.1 0 0 0-0.1 0 0 0 0-0.1-0.1 0-0.2-0.1-0.1-0.1-0.1-0.2 0-0.1 0-0.2 0-0.1 0-0.2 0.3-0.6 0.7-1.1 0.5-0.4 1-0.8 0.5-0.4 1.1-0.6 0.6-0.3 1.3-0.4 0.1 0 0.2 0.1 0.1 0 0.1 0.1 0.1 0 0.2 0.1 0 0.1 0 0.2 0 0.1 0 0.2 0 0.1-0.1 0.2-0.1 0.1-0.2 0.1-0.1 0.1-0.2 0.1-0.5 0.1-0.9 0.3-0.5 0.1-0.9 0.4-0.4 0.3-0.7 0.7-0.4 0.4-0.6 0.8 0 0.1-0.1 0.2 0 0-0.1 0.1 0 0-0.1 0-0.1 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m260.3 216.8q-0.1 0-0.1 0-0.1 0-0.2 0 0-0.1-0.1-0.1 0-0.1-0.1-0.1-0.2-0.4-0.6-0.8-0.4-0.4-0.9-0.6-0.4-0.3-0.9-0.4-0.5-0.2-1-0.2-0.2-0.1-0.3-0.2-0.2-0.2-0.2-0.4 0-0.2 0.2-0.3 0.1-0.2 0.3-0.2 0.6 0 1.3 0.2 0.6 0.2 1.1 0.5 0.6 0.3 1.1 0.8 0.4 0.4 0.8 1 0.1 0.1 0.1 0.2 0 0.1 0 0.2 0 0.1-0.1 0.2 0 0-0.1 0.1 0 0-0.1 0.1 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m254.8 238.1c-3.8 0.3-5.7-1.2-6.8-3.1q1.3-0.2 2.6-0.3 1.2-0.1 2.5-0.1 1.3 0 2.5 0 1.3 0 2.6 0.1c0 0 0.3 3-3.4 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m252.8 236.6q0.5-0.1 1.1-0.1 0.5 0 1.1 0.1 0.5 0.1 1 0.3 0.6 0.1 1.1 0.3-0.3 0.2-0.6 0.4-0.2 0.1-0.5 0.2-0.3 0.1-0.6 0.2-0.3 0-0.6 0-0.6 0.1-1.1 0.1-0.6 0-1.1-0.1-0.6 0-1.1-0.2-0.5-0.1-1-0.4 0.3-0.2 0.5-0.3 0.3-0.1 0.6-0.2 0.3-0.1 0.6-0.2 0.3-0.1 0.6-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m257.8 234.6q0 0.2-0.1 0.4-0.1 0.2-0.2 0.3-0.2 0.2-0.4 0.3-0.1 0.1-0.3 0.1-0.9 0.1-1.7 0.1-0.8 0.1-1.6 0.1-0.9 0-1.7-0.1-0.8 0-1.6-0.1-0.3 0-0.5 0-0.3-0.1-0.5-0.2-0.3-0.1-0.5-0.2-0.2-0.2-0.3-0.4 1.2-0.1 2.3-0.2 1.2-0.1 2.4-0.1 1.2 0 2.3 0 1.2 0 2.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m221.4 210.4l14.4-10.1 11.7 3.3c0 0-9.2-0.2-9.6 6.3-0.4 6.6-6.5 9.8-4.8 16.6 1.7 6.9-3.4 9.3-3.4 9.3l-6.7-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer copy",
    className: "s12",
    d: "m223.7 211.5c-4.1-0.7-8-4.8-4-9.8-0.9-4.1 5.4-8.7 10.6-7.7 3.1-3.5 6.9-2.8 12.4-1.3q0.9-0.8 2.1-1.2 1.1-0.4 2.4-0.5 1.2-0.1 2.4 0.2 1.2 0.3 2.2 0.9c2.6 1.7 5.3 0.4 5.4-0.7 5.2 2.4 7.2 6.7 5.6 11.4-1.6 4.8-5.1 4.2-8.5 4.2-1.7 2.2-6.9 2-10.9 0.2-0.9 2.4-4.9 4.9-9.8 3.3-1.1 2.1-9.1 3.1-9.9 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s13",
    d: "m263.8 221.9l-6.3 3.5-3.3-3.3-2.1 4.6-8 0.4-2.7-4.2-10 8.3-1-1.6 10.6-10.1 21-3.5zm-10.5-0.9l-0.8-2.2-10.3 1.6 2.6 5.3 6.4-0.4zm4.5 3l4.8-2.7-1.4-4.4-7.1 1.4 0.7 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s23",
    d: "m263.8 221.9l-6.3 3.5-3.3-3.3-2.1 4.6-8 0.4-2.7-4.2-10 8.3-1-1.6 10.6-10.1 21-3.5zm-10.5-0.9l-0.8-2.2-10.3 1.6 2.6 5.3 6.4-0.4zm4.5 3l4.8-2.7-1.4-4.4-7.1 1.4 0.7 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m223 234.7c-0.2-0.9-0.1-1.7 0.1-2.6 0.2-0.8 0.6-1.6 1.2-2.2 0.6-0.6 1.4-1.1 2.2-1.4 3.8-1.2 7.7 2.7 9.2 5.9 1.7 3.5 0.3 7.3-3.7 6.8q-1.2-0.1-2.3-0.4-1-0.4-2-0.9-1-0.6-1.9-1.3-0.9-0.7-1.6-1.6c-0.5-0.7-1-1.5-1.2-2.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m249.9 274.4q-0.6 1-1.2 2-0.5 1-0.9 2.1-0.3 1.1-0.6 2.3-0.2 1.1-0.3 2.3c0 0.7-21.2-7.4-20.4-18.3 0 0 2.9-1.8 4.8-3.2 0 0 0.8 8.5 18.6 12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m255 263.6q0.7 0.2 1.4 0.3 0.7 0.2 1.4 0.4 0.7 0.2 1.3 0.5 0.7 0.2 1.4 0.5c3.1 10.7-6 17.8-6.3 17.1q-0.4-1.1-0.8-2.1-0.5-1-1.1-2-0.5-1.1-1.1-2-0.6-1-1.3-1.9c6.6-2.3 4.7-10.9 5.1-10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m279.7 380.3c0 0 3.9 87 3.5 124.6-0.4 39.1-10.9 153.1-10.9 153.1h-20.9c0 0-3.8-111.7-5.7-150.1-0.2-3.8-0.4-8-0.7-12.5q0-0.1 0-0.3c-1.4-23.5-3.7-54.5-5.6-78.3-1.7-21-3-36.5-3-36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m274.9 650.8l-0.8 7.7h-24.1c0 0-0.2-6.8-0.1-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m251.5 399.6c0.7 45.7-1.4 73.5-6.5 95.8q0-0.1 0-0.3c-1.4-23.5-3.7-54.5-5.6-78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m256.3 380.3c0 0-11.6 89.1-18.5 124.4-7.4 38.7-50 137.1-50 137.1l-21.9-5.5c0 0 31.2-89.8 35.1-128.1 4.1-41.4 12.8-127.8 12.8-127.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m200.9 286.5l15.9 8.5c0 0-18.1 39.1-15.7 45 3.2 7.9 8.3 25.4 13.8 34-0.5 2-3.2 6.7-4.8 7.7-12.7-7.8-27.2-34.4-27.5-42.2-0.6-17.6 18.3-53 18.3-53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m223.5 290.5c-5 14.3-15.3 33.5-15.3 33.5l-24.9-13.9c0 0 12.4-40.4 24-42.1 12.5-1.8 21.3 7.5 16.2 22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m223.5 290.5c-5 14.3-15.3 33.5-15.3 33.5l-24.9-13.9c0 0 12.4-40.4 24-42.1 12.5-1.8 21.3 7.5 16.2 22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s13",
    d: "m179.7 657.6q-0.4-0.1-0.8-0.3-0.3-0.2-0.7-0.4-0.3-0.2-0.7-0.5 0 0 0 0-0.1-0.1-0.1-0.1 0-0.1 0-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0 0 0.1-0.1 0.1-0.1 0 0 0.1 0c0.5 0 5-1.1 6.1 0q0.1 0.1 0.1 0.2 0.1 0.1 0.1 0.2 0.1 0.2 0 0.3 0 0.1 0 0.2 0 0.2-0.1 0.4-0.1 0.2-0.3 0.4-0.1 0.2-0.3 0.3-0.1 0.1-0.3 0.2-0.3 0.1-0.6 0.1-0.4 0.1-0.7 0-0.3 0-0.6 0-0.3-0.1-0.6-0.2-0.3-0.2-0.7-0.4zm2.1-1.6q-0.6 0-1.2 0-0.5 0-1.1 0.1-0.6 0.1-1.1 0.3 0.4 0.3 0.9 0.6 0.5 0.2 1 0.4 0.6 0.1 1.1 0.2 0.6 0 1.2 0 0.1-0.1 0.2-0.2 0.1-0.1 0.2-0.2 0.1-0.1 0.2-0.2 0-0.2 0.1-0.3 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1-0.1 0-0.1-0.1 0 0-0.1 0 0 0-0.1-0.1 0 0-0.1 0-0.5-0.1-1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s13",
    d: "m177.5 656.5q0 0 0 0-0.1 0-0.1 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0c0.1-0.2 1.4-3.5 3.1-4.1q0.1-0.1 0.3-0.1 0.2-0.1 0.3-0.1 0.2 0 0.4 0.1 0.1 0 0.3 0.1 0.1 0 0.3 0.1 0.1 0.1 0.2 0.3 0.1 0.1 0.1 0.3 0.1 0.1 0 0.3c-0.1 1.4-3.3 3.2-4.7 3.4h-0.1q-0.1 0-0.1 0zm3.7-4q0 0-0.1 0-0.1 0-0.2 0-0.1 0-0.2 0c-1.1 0.5-2.1 2.3-2.5 3.3 1.5-0.5 3.7-2 3.7-2.8 0-0.1 0-0.3-0.4-0.4h-0.1q-0.1-0.1-0.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s13",
    d: "m271.6 675.4q-0.5 0-1-0.1-0.5-0.1-0.9-0.1-0.5-0.1-1-0.2-0.1 0-0.1 0 0-0.1-0.1-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0-0.1 0-0.1 0.1 0 0.1-0.1c0.6-0.3 5.4-2.8 7-1.9q0.1 0 0.2 0.1 0.1 0.1 0.1 0.2 0.1 0.1 0.1 0.2 0.1 0.1 0.1 0.3 0 0.1 0 0.3 0 0.2-0.1 0.4-0.1 0.2-0.2 0.4-0.1 0.1-0.2 0.3-0.4 0.2-0.7 0.4-0.4 0.1-0.8 0.2-0.3 0.1-0.7 0.1-0.4 0.1-0.8 0-0.5 0-1 0zm1.8-2.3q-0.6 0.2-1.3 0.4-0.6 0.2-1.2 0.5-0.7 0.3-1.2 0.6c2.7 0.4 4.7 0.3 5.5-0.4q0.1 0 0.1-0.2 0.1-0.1 0.1-0.2 0.1-0.1 0.1-0.2 0-0.2 0-0.3 0 0 0-0.1 0 0-0.1-0.1 0 0 0-0.1-0.1 0-0.1 0-0.1 0-0.1-0.1-0.1 0-0.2 0 0 0-0.1 0-0.1 0-0.2 0-0.6 0.1-1.3 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s13",
    d: "m268.7 675q0 0 0 0 0 0-0.1 0 0 0 0 0 0-0.1 0-0.1-0.1 0-0.1-0.1 0 0 0 0 0-0.1 0-0.1c0-0.2 0.2-3.5 1.8-4.7q0.1-0.2 0.3-0.3 0.2-0.1 0.5-0.2 0.2 0 0.4-0.1 0.2 0 0.4 0.1c0.8 0 1.2 0.4 1.2 0.8 0.2 1.4-2.7 4-4.1 4.7h-0.2q-0.1 0-0.1 0zm2.9-5q-0.1 0-0.2 0-0.2 0-0.3 0.1-0.1 0-0.3 0.1-0.1 0.1-0.2 0.2-0.3 0.4-0.6 0.8-0.3 0.5-0.5 1-0.2 0.4-0.3 1-0.1 0.5-0.1 1c1.5-0.9 3.4-3 3.3-3.9 0 0-0.1-0.3-0.6-0.3h-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m212.6 372.4l11.6 1.2-8.1 11.7c0 0-10.2-1.3-10.7-9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m230.9 378.2l-7.9 10.2-6.8-3.1 8.1-11.7 6.6 4.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Message--inject-8"
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m649.1 371.8l11.6 134.5c1 10.9-5.7 20.5-14.9 21.3l-255.2 21.9c-9.1 0.8-17.4-7.5-18.3-18.5l-11.6-134.5q0-0.9-0.1-1.9 0-0.9 0.1-1.9 0.1-0.9 0.2-1.8 0.2-1 0.4-1.9c1.8-7.5 7.4-13.3 14.3-13.8l255.2-21.9c7-0.6 13.3 4.1 16.5 11.1q0.4 0.9 0.7 1.8 0.3 0.9 0.5 1.8 0.2 1 0.4 1.9 0.2 0.9 0.2 1.9z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m649.1 371.8l11.6 134.5c1 10.9-5.7 20.5-14.9 21.3l-255.2 21.9c-9.1 0.8-17.4-7.5-18.3-18.5l-11.6-134.5q0-0.9-0.1-1.9 0-0.9 0.1-1.9 0.1-0.9 0.2-1.8 0.2-1 0.4-1.9c1.8-7.5 7.4-13.3 14.3-13.8l255.2-21.9c7-0.6 13.3 4.1 16.5 11.1q0.4 0.9 0.7 1.8 0.3 0.9 0.5 1.8 0.2 1 0.4 1.9 0.2 0.9 0.2 1.9z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m677.6 451.3l1.8-0.2 0.8 6-1.8 0.2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m674.1 422l1.8-0.2 2.7 22.6-1.8 0.2z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m660.6 347.7l16.7 138c1.3 11.2-5.2 21.3-14.6 22.4l-261.7 31.7c-9.4 1.1-18.2-7.1-19.5-18.4l-16.7-137.9q-0.1-1-0.2-1.9 0-1 0-2 0.1-1 0.2-1.9 0.1-1 0.3-2c1.7-7.7 7.1-13.8 14.2-14.7l261.8-31.6c7.1-0.9 13.9 3.7 17.3 10.9q0.4 0.8 0.8 1.7 0.3 1 0.6 1.9 0.3 0.9 0.5 1.9 0.1 1 0.3 1.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m658.4 340.3l-118.7 79.9c-2.9 2-6 3.6-9.3 4.8-3.3 1.3-6.7 2.1-10.2 2.5-3.5 0.4-7 0.4-10.5 0-3.5-0.4-6.9-1.2-10.2-2.5l-134.3-49.3c1.6-7.7 7.1-13.8 14.2-14.7l261.7-31.6c7.1-0.9 13.9 3.7 17.3 10.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m614.1 370.1l-34.1 22.9-11.2 7.5-29.1 19.7c-2.8 1.9-5.9 3.5-9.1 4.7-3.2 1.3-6.5 2.1-9.9 2.6-3.4 0.4-6.8 0.5-10.2 0.1-3.4-0.3-6.8-1.1-10-2.2l-1-0.4-16.4-6-36.8-13.5-17.2-6.3-19.5-7.2-1.5-34.4-3.1-76.7 149.8-6.1 57.1 43.3 0.6 14.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m614.1 370.1l-34.1 22.9-11.2 7.5-29.1 19.7c-2.8 1.9-5.9 3.5-9.1 4.7-3.2 1.3-6.5 2.1-9.9 2.6-3.4 0.4-6.8 0.5-10.2 0.1-3.4-0.3-6.8-1.1-10-2.2l-1-0.4-16.4-6-36.8-13.5-17.2-6.3-19.5-7.2-1.5-34.4-3.1-76.7 149.8-6.1 57.1 43.3 0.6 14.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.9
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m593 333.3l-165.9 6.8q-0.7 0-1.3-0.2-0.7-0.3-1.2-0.7-0.5-0.5-0.8-1.1-0.3-0.6-0.4-1.3 0-0.7 0.2-1.4 0.3-0.6 0.7-1.1 0.5-0.6 1.1-0.9 0.6-0.3 1.3-0.3l165.9-6.7q0.7-0.1 1.4 0.2 0.6 0.2 1.1 0.7 0.6 0.4 0.9 1.1 0.3 0.6 0.3 1.3 0 0.7-0.2 1.3-0.2 0.7-0.7 1.2-0.5 0.5-1.1 0.8-0.6 0.3-1.3 0.3z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m593.9 355.4l-165.9 6.7q-0.7 0.1-1.4-0.2-0.6-0.2-1.1-0.7-0.5-0.4-0.9-1.1-0.3-0.6-0.3-1.3 0-0.7 0.2-1.3 0.3-0.7 0.7-1.2 0.5-0.5 1.1-0.8 0.6-0.3 1.3-0.4l165.9-6.7q0.7 0 1.3 0.2 0.7 0.2 1.2 0.7 0.5 0.5 0.8 1.1 0.3 0.6 0.4 1.3 0 0.7-0.2 1.4-0.3 0.6-0.7 1.1-0.5 0.5-1.1 0.8-0.6 0.3-1.3 0.4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m594.8 377.4l-165.9 6.8q-0.7 0-1.4-0.3-0.6-0.2-1.1-0.7-0.6-0.4-0.9-1-0.3-0.7-0.3-1.4 0-0.7 0.2-1.3 0.2-0.7 0.7-1.2 0.5-0.5 1.1-0.8 0.6-0.3 1.3-0.3l165.9-6.8q0.7 0 1.3 0.2 0.7 0.3 1.2 0.8 0.5 0.4 0.8 1 0.3 0.7 0.4 1.4 0 0.6-0.2 1.3-0.3 0.6-0.7 1.2-0.5 0.5-1.1 0.8-0.7 0.3-1.3 0.3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m580 393l-11.2 7.5-122.5 5-17.2-6.3q0 0 0.1 0 0 0 0.1 0 0 0 0.1 0 0 0 0.1 0z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m534.6 420.5v0.1q0 0.7-0.3 1.3-0.2 0.6-0.7 1.1-0.4 0.5-1 0.8-0.6 0.3-1.3 0.4l-30.7 1.2-1.1-0.4-16.3-6 47.8-1.9q0.7 0 1.3 0.2 0.7 0.3 1.2 0.7 0.5 0.5 0.8 1.2 0.3 0.6 0.3 1.3z"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m612 318.1l-39.7-1.7-17.4-41.6 57.1 43.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m612 318.1l-38.5-6.6-18.6-36.7 57.1 43.3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m688.3 157.2c0 33.8-37 66.9-42.5 66.9-5.5 0-42.5-33.1-42.5-66.9 0-22.6 19-40.9 42.5-40.9 23.5 0 42.5 18.3 42.5 40.9z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m637.9 148.8c-7.7 8.5-18.1 11.5-23.3 6.7-5.2-4.9-3.2-15.4 4.5-23.9 7.7-8.4 18.1-11.5 23.3-6.7 5.2 4.7 3.2 15.5-4.5 23.9z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m615.2 182.8c-1-2.5-0.7-5 0.6-5.5 1.4-0.6 3.3 1 4.3 3.6 0.9 2.5 0.7 4.9-0.6 5.5-1.4 0.5-3.3-1.1-4.3-3.6z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m644 330.3q-0.2 0-0.3-0.1-0.1 0-0.2-0.1-0.1-0.1-0.1-0.2-0.1-0.1-0.1-0.3 0-0.8 0.1-1.6 0.1-0.9 0.4-1.7 0.2-0.8 0.6-1.5 0.3-0.8 0.8-1.4 0.9-1.3 1.3-2.7 0.4-1.4 0.4-2.9 0-1.5-0.4-2.9-0.4-1.4-1.3-2.6-0.9-1.4-1.4-3-0.5-1.6-0.5-3.3 0-1.6 0.5-3.2 0.5-1.6 1.4-3 0.9-1.2 1.3-2.7 0.4-1.4 0.4-2.9 0-1.4-0.4-2.9-0.4-1.4-1.3-2.6-0.9-1.4-1.4-3-0.5-1.6-0.5-3.2 0-1.7 0.5-3.3 0.5-1.6 1.4-3 0.9-1.2 1.3-2.6 0.4-1.4 0.4-2.9 0-1.5-0.4-2.9-0.4-1.4-1.3-2.6-0.9-1.4-1.4-3-0.5-1.6-0.5-3.3 0-1.7 0.5-3.3 0.5-1.6 1.4-2.9 0.9-1.3 1.3-2.7 0.4-1.4 0.4-2.9 0-1.4-0.4-2.9-0.4-1.4-1.3-2.6-0.9-1.4-1.4-3-0.5-1.6-0.5-3.2 0-1.7 0.5-3.3 0.5-1.6 1.4-3 0.4-0.6 0.8-1.3 0.3-0.6 0.5-1.3 0.2-0.7 0.3-1.4 0.1-0.8 0.1-1.5 0-0.3 0.2-0.4 0.2-0.2 0.5-0.2 0.2 0 0.4 0.2 0.2 0.1 0.3 0.4 0 0.8-0.1 1.6-0.2 0.9-0.4 1.7-0.2 0.8-0.6 1.5-0.4 0.7-0.9 1.4-0.4 0.6-0.7 1.3-0.3 0.7-0.5 1.4-0.3 0.7-0.4 1.4 0 0.7 0 1.5 0 0.7 0 1.4 0.1 0.8 0.4 1.5 0.2 0.7 0.5 1.3 0.3 0.7 0.7 1.3 1 1.4 1.5 3 0.5 1.6 0.5 3.2 0 1.7-0.5 3.3-0.5 1.6-1.5 3-0.8 1.2-1.3 2.6-0.4 1.4-0.4 2.9 0 1.5 0.4 2.9 0.5 1.4 1.3 2.6 1 1.4 1.5 3 0.5 1.6 0.5 3.3 0 1.7-0.5 3.3-0.5 1.6-1.5 2.9-0.8 1.3-1.3 2.7-0.4 1.4-0.4 2.9 0 1.4 0.4 2.9 0.5 1.4 1.3 2.6 1 1.4 1.5 3 0.5 1.6 0.5 3.2 0 1.7-0.5 3.3-0.5 1.6-1.5 3-0.8 1.2-1.3 2.6-0.4 1.4-0.4 2.9 0 1.5 0.4 2.9 0.5 1.4 1.3 2.7 1 1.4 1.5 3 0.5 1.6 0.5 3.2 0 1.7-0.5 3.3-0.5 1.6-1.5 3-0.4 0.6-0.7 1.2-0.3 0.7-0.5 1.4-0.3 0.7-0.4 1.4-0.1 0.8 0 1.5 0 0.2-0.1 0.3 0 0.1-0.1 0.2-0.1 0.1-0.3 0.2-0.1 0-0.2 0z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m655.8 238.3h-20c0-8 8.7-15.8 10-15.8 1.4 0 10 7.8 10 15.8z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m643.3 223.4c0-0.3 0.2-0.6 0.5-0.6h4c0.3 0 0.5 0.3 0.5 0.6v0.4c0 0.3-0.2 0.6-0.5 0.6h-4c-0.3 0-0.5-0.3-0.5-0.6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m421.6 188.8c0 33.7-37 66.9-42.6 66.9-5.5 0-42.5-33.2-42.5-66.9 0-22.7 19.1-41 42.5-41 23.5 0 42.6 18.3 42.6 41z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m372.2 181.7c-7.7 8.5-18.2 11.5-23.4 6.7-5.2-4.7-3.2-15.4 4.5-23.8 7.7-8.5 18.2-11.5 23.4-6.7 5.2 4.7 3.2 15.4-4.5 23.8z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m349.5 215.7c-1-2.5-0.8-5 0.6-5.5 1.3-0.6 3.3 1 4.2 3.6 1 2.5 0.8 4.9-0.6 5.5-1.3 0.6-3.2-1.1-4.2-3.6z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m377.2 361.8q-0.2 0-0.3 0-0.1-0.1-0.2-0.2-0.1-0.1-0.2-0.2 0-0.1 0-0.3 0-0.8 0.1-1.6 0.1-0.9 0.3-1.6 0.3-0.8 0.6-1.6 0.4-0.7 0.9-1.4 0.8-1.2 1.3-2.7 0.4-1.4 0.4-2.9 0-1.4-0.4-2.9-0.5-1.4-1.3-2.6-0.9-1.4-1.4-3-0.5-1.6-0.5-3.3 0-1.6 0.5-3.2 0.5-1.6 1.4-3 0.4-0.6 0.7-1.3 0.4-0.6 0.6-1.3 0.2-0.7 0.3-1.5 0.1-0.7 0.1-1.4 0-0.8-0.1-1.5-0.1-0.7-0.3-1.4-0.2-0.7-0.6-1.4-0.3-0.7-0.7-1.3-0.9-1.4-1.4-2.9-0.5-1.6-0.5-3.3 0-1.7 0.5-3.3 0.5-1.6 1.4-3 0.4-0.6 0.7-1.2 0.4-0.7 0.6-1.4 0.2-0.7 0.3-1.4 0.1-0.8 0.1-1.5 0-0.7-0.1-1.5-0.1-0.7-0.3-1.4-0.2-0.7-0.6-1.4-0.3-0.6-0.7-1.2-0.9-1.4-1.4-3-0.5-1.6-0.5-3.3 0-1.6 0.5-3.2 0.5-1.6 1.4-3 0.8-1.2 1.3-2.6 0.4-1.5 0.4-2.9 0-1.5-0.4-2.9-0.5-1.4-1.3-2.7-0.9-1.3-1.4-2.9-0.5-1.6-0.5-3.3 0-1.7 0.5-3.3 0.5-1.6 1.4-3 0.4-0.6 0.7-1.2 0.4-0.7 0.6-1.4 0.2-0.7 0.3-1.4 0.1-0.8 0.1-1.5 0-0.1 0-0.3 0.1-0.1 0.2-0.2 0.1-0.1 0.2-0.1 0.1-0.1 0.2-0.1 0.2 0 0.3 0.1 0.1 0 0.2 0.1 0.1 0.1 0.2 0.2 0 0.2 0 0.3 0 0.8-0.1 1.7-0.1 0.8-0.3 1.6-0.3 0.8-0.6 1.5-0.4 0.8-0.9 1.5-0.8 1.2-1.3 2.6-0.4 1.4-0.4 2.9 0 1.5 0.4 2.9 0.5 1.4 1.3 2.6 0.9 1.4 1.4 3 0.5 1.6 0.5 3.3 0 1.6-0.5 3.2-0.5 1.6-1.4 3-0.4 0.6-0.7 1.3-0.3 0.6-0.6 1.3-0.2 0.7-0.3 1.5-0.1 0.7 0 1.4-0.1 0.8 0 1.5 0.1 0.7 0.3 1.4 0.2 0.7 0.6 1.4 0.3 0.7 0.7 1.3 0.9 1.3 1.4 2.9 0.5 1.6 0.5 3.3 0 1.7-0.5 3.3-0.5 1.6-1.4 3-0.4 0.6-0.7 1.2-0.3 0.7-0.6 1.4-0.2 0.7-0.3 1.4-0.1 0.8 0 1.5-0.1 0.7 0 1.5 0.1 0.7 0.3 1.4 0.2 0.7 0.6 1.4 0.3 0.6 0.7 1.2 0.9 1.4 1.4 3 0.5 1.6 0.5 3.3 0 1.6-0.5 3.2-0.5 1.6-1.4 3-0.8 1.2-1.3 2.6-0.4 1.5-0.4 2.9 0 1.5 0.4 2.9 0.5 1.5 1.3 2.7 0.9 1.4 1.4 3 0.5 1.6 0.5 3.2 0 1.7-0.5 3.3-0.5 1.6-1.4 3-0.4 0.6-0.7 1.3-0.4 0.6-0.6 1.3-0.2 0.7-0.3 1.5-0.1 0.7 0 1.4 0 0.2-0.1 0.3-0.1 0.1-0.1 0.2-0.1 0.1-0.3 0.2-0.1 0-0.2 0z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m388.9 269.8h-19.9c0-7.9 8.7-15.7 10-15.7 1.3 0 10 7.8 9.9 15.7z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m376.4 254.9c0-0.3 0.3-0.6 0.6-0.6h3.9c0.4 0 0.6 0.3 0.6 0.6v0.4c0 0.3-0.2 0.6-0.6 0.6h-3.9c-0.3 0-0.6-0.3-0.6-0.6z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m668.8 361.1c-10 9.2-25.6 8.6-34.9-1.5-9.2-10.1-8.6-25.7 1.5-34.9 10.1-9.2 25.7-8.6 34.9 1.5 9.2 10.1 8.6 25.7-1.5 34.9z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m657 331v24.9h-6.9v-16.3q-0.3 0.3-0.7 0.5-0.4 0.3-0.8 0.6-0.4 0.2-0.8 0.5-0.5 0.2-0.9 0.4-0.5 0.3-0.9 0.5-0.5 0.2-1 0.4-0.5 0.1-1 0.3-0.5 0.2-1 0.3v-5.5q0.7-0.2 1.4-0.5 0.7-0.3 1.4-0.6 0.7-0.4 1.3-0.8 0.7-0.4 1.3-0.8 0.5-0.4 0.9-0.9 0.4-0.4 0.8-0.9 0.4-0.5 0.7-1 0.3-0.5 0.6-1.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.fb87580bb225a8f105267967260eb9fa.svg";
export { ForwardRef as ReactComponent };